<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="showModal = true" id="show-modal"></v-btn>
  </v-row>
  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table>
            <thead>
              <tr>
                <th class="table-heading-text">identifier</th>
                <th class="table-heading-text text-right">annual amount</th>
              </tr>
            </thead>
            <tbody>
              <tr class="remove-bottom-border" v-for="salary in salaries.salaries" :key="salary.id" @click="showEditModal(salary )">
                <td class="table-content-text text-left"> {{ salary.identifier }}</td>
                <td class="table-content-text text-right">{{ salary.annual_amount.toLocaleString() }}</td>
              </tr>
              <tr class="add-top-border">
                <td></td>
                <td class="table-heading-text text-right">{{ Number(salaries.total_annual_amount).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  
  <!-- Modals-->
  <SalaryModalPopup :show="showModal" @close="showModal = false"></SalaryModalPopup> <!-- add a new record -->

  <SalaryEditModalPopup :show="showEditModalToggle" :currentRow="selectedRow" @close="showEditModalToggle = false"></SalaryEditModalPopup> <!--edit a record -->

</template>

<script>
import axios from 'axios';
import SalaryModalPopup from './modals/SalaryNewModalPopup.vue';
import SalaryEditModalPopup from './modals/SalaryEditModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    SalaryModalPopup,
    SalaryEditModalPopup
  },
  data() {
    return {
      salaries: [],
      showModal: false,
      showEditModalToggle: false,
      selectedRow: {}
    };
  },
  async created() {
    this.getSalaries();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'salaries',
          disabled: true,
          href: ''
        },
      ];
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditModal(row){
     this.selectedRow=row;
     this.showEditModalToggle = true;
    },
    async getSalaries(){
      try {
      const response  = await axios.get("/salaries/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.salaries = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load salaries' });
      }
    }
  }
};
</script>


<style scoped>

table tr{
  cursor: pointer;
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300 !important;
}

.table-content-text{
  font-size: 1.05rem;
  font-weight: 300 !important;
}

.remove-bottom-border td{
  border-bottom: none !important;
}

.add-top-border td{
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

</style>